import React from 'react';
import { useTranslation } from 'react-i18next';
import { ObjectCardSkeleton } from '../ObjectCardSkeleton';
import { NS } from '../../i18n';
import './ObjectGridSkeleton.css';

type Props = {
  count?: number;
};

export const ObjectGridSkeleton: React.FC<Props> = ({ count = 6 }) => {
  const { t } = useTranslation(NS);
  return (
    <div className="object-grid-skeleton" aria-busy aria-label={t('grid.loadingAriaLabel')}>
      {Array.from({ length: count }).map((_, i) => (
        <ObjectCardSkeleton key={i} />
      ))}
    </div>
  );
};
